import { Component, Input, OnInit } from '@angular/core';
import { Highlight } from 'ngx-highlightjs';
import { Shadow } from '../../models/shadow';

@Component({
  selector: 'app-shadow-panel',
  standalone: true,
  imports: [Highlight],
  templateUrl: './shadow-panel.component.html',
})
export class ShadowPanelComponent implements OnInit {
  @Input() shadow!: Shadow;

  stringifiedShadow: string = '';

  ngOnInit(): void {
    if (this.shadow?.getState()) {
      this.stringifiedShadow = JSON.stringify(this.shadow.getState(), null, 2);
    }
  }
}
